import { render, staticRenderFns } from "./BuscaUsuario.vue?vue&type=template&id=739844bb&scoped=true"
import script from "./BuscaUsuario.vue?vue&type=script&lang=js"
export * from "./BuscaUsuario.vue?vue&type=script&lang=js"
import style0 from "./BuscaUsuario.vue?vue&type=style&index=0&id=739844bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739844bb",
  null
  
)

export default component.exports